export default __webpack_public_path__ + "static/media/system.027709ed.jpeg";